import { AxiosResponse } from 'axios'
import SecureClient from '../SecureClient'
import { BaseWorkflowFailureActionInstance, WorkflowFailureActionInstance, WorkflowFailureActionInstanceMetadata } from './DTOs'

export default class WorkflowFailureActionInstancesClient extends SecureClient {
	/**
	 *
	 */
	constructor() {
		super()
	}

	public getFailureActionInstances = (workflowId?: number): Promise<
		AxiosResponse<WorkflowFailureActionInstance[]>
	> => {
		return this._api.get<WorkflowFailureActionInstance[]>(`WorkflowFailureActionInstances`, {
			headers: {
				...this.acceptHeader(),
				...this.contentTypeHeader(),
				...this.authorizationHeader,
			},
			params: {
				workflowId
			}
		})
	}

	public getMetadataForInstances = (workflowId?: number): Promise<
		AxiosResponse<WorkflowFailureActionInstanceMetadata[]>
	> => {
		return this._api.get<WorkflowFailureActionInstanceMetadata[]>(
			`WorkflowFailureActionInstances/Metadata`,
			{
				headers: {
					...this.acceptHeader(),
					...this.contentTypeHeader(),
					...this.authorizationHeader,
				},
				params: {
					workflowId
				}
			},
		)
	}

	public getInstance = (
		instanceId: number,
	): Promise<AxiosResponse<WorkflowFailureActionInstance>> => {
		return this._api.get<WorkflowFailureActionInstance>(
			`WorkflowFailureActionInstances/${instanceId}`,
			{
				headers: {
					...this.acceptHeader(),
					...this.contentTypeHeader(),
					...this.authorizationHeader,
				},
			},
		)
	}


	public create = (
		instance: BaseWorkflowFailureActionInstance,
	): Promise<AxiosResponse<WorkflowFailureActionInstance>> => {
		return this._api.post<WorkflowFailureActionInstance>(
			`WorkflowFailureActionInstances`,
			instance,
			{
				headers: {
					...this.acceptHeader(),
					...this.contentTypeHeader(),
					...this.authorizationHeader,
				},
			},
		)
	}

	public updateInstance = (
		instanceId: number,
		instance: BaseWorkflowFailureActionInstance,
	): Promise<AxiosResponse<WorkflowFailureActionInstance>> => {
		return this._api.put(`WorkflowFailureActionInstances/${instanceId}`, instance, {
			headers: {
				...this.acceptHeader(),
				...this.contentTypeHeader(),
				...this.authorizationHeader,
			},
		})
	}

	public deleteInstance = (instanceId: number): Promise<AxiosResponse> => {
		return this._api.delete(`WorkflowFailureActionInstances/${instanceId}`, {
			headers: {
				...this.acceptHeader(),
				...this.contentTypeHeader(),
				...this.authorizationHeader,
			},
		})
	}
}
